import React, { useState, useEffect, Fragment } from "react";
import Location from "components/sales/formSection/location/locationOnboarding";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useContext } from "react";
import BulkUpload from "components/sales/bulkUpload/bulkUpload";
import Layout from 'components/sales/layout/layout';
import FormSection from 'components/sales/formSection/formSectionNew';
import SearchLocation from 'components/sales/searchLocation/searchLocation';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { isAddLocationSuccess } from "services/redux/sales/projectOnboarding/action";
const AddLocationDetailsAll = ({
                        match,
                        history,
                        locationCity,
                        cities,
                        locationZone,
                        zones,
                        locationArea,
                        areas,
                        locationType,
                        locTypesData,
                        locationState,
                        locationPinCode,
                        pincodeData,
                        getCurrentLocation,
                        latlng,
                        lat,
                        lng,
                        currentLocation,
                        toastMsg,
                        addLocationDetailsData
                    }) => {
    const corporateInput = {
        location: null,
        type:null,
        lead_id:null
    };
    const inputs = {
        lat: '',
        lng: ''
        };
    const [formData, setData] = useState(inputs);
    const {parameter} = useParams();
    const { baseUrl } = useContext(BaseUrl);
    const [isModal, setIsModal] = useState(false);
    const [corporateData, setCorporateData] = useState(corporateInput);
    const [isFiled, setIsFiled] = useState(false);
    const [isbulk, setIsbulk] = useState(false);
    const [isUploaded, setIsuploaded] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);
    // const [isLoading, setIsLoading] = useState(false);
    const [isDefalut, setIsDefalut] = useState(false);
    const [isSupply, setIsSupply] = useState(false);
    const [isApt, setIsApt] = useState(false);
    const [dropdown, setDropDown] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showAddForm, setAddForm] = useState(false);
    const [isEnable, setIsEnable] = useState(true);
    const [type, setType] = useState(null);
    const [leadId, setLeadId] = useState(null);
    const [registeredName, setRegisteredName] = useState('');
    const [isInputError, setIsInputError] = useState({
        latError: false,
        longError: false,
        pinError: false,
        crl: false,
        isPinNotFound: false,
    });
    console.log('PAGE::LOCATION FOR ALL');
    const [optOption, setOptOption] = useState({
        address2: '',
        currentLocation: '',
    });

    const handleLocSubmit = (val) => {
        setCorporateData({ ...corporateData, location: val });
        setIsDefalut(false);
    };
    
    const handleCurrentLocationChange = (value) => {
        setOptOption({ ...optOption, currentLocation: value });
        localStorage.setItem('currentLocation', value);
    };

    useEffect(() => {
       if(match.params.type) {
            setIsLoading(true);
            setType(match.params.type); 
            setLeadId(match.params.lead_id); 
            setIsLoading(false); 
       }
    },[match.params.type,match.params.lead_id]);

    const handleSubmit = () => {
        console.log(corporateData);
        console.log('submit!');
        //console.log(registeredName);
        //return false;
        const {
            location
        } = corporateData;
        if (
            location === null 
            // categoryDetails === null
        ) { 
            setIsFiled(true);
            setIsModal(false);
            return false;
        } else {
            setIsFiled(false);
            (async () => {
                setIsLoading(true);
                const res = await addLocationDetailsData({
                    location,
                    type,
                    leadId,
                    registeredName
                });
                setIsLoading(false);
                localStorage.removeItem("currentLocation");
                if (isAddLocationSuccess(res)) {
                    toast.success('Address added successfully.');
                    history.push(`${baseUrl}/business-lists`);
                } else {
                    toast.error('Something went wrong, Please try again.');
                }
            })();
        }
    };

    const handleFileChange = (val) => setBulkFile(val);

    const headerBtns = () => {
        return (
            <Fragment>
                <Button onClick={() => setIsbulk(true)} className="btn btn-transparent">
                    {localization.bulkUpload}
                </Button>
            </Fragment>
        );
    };

    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng !== null && latlng !== undefined) {
          const { lat, lng } = latlng;
          console.log(latlng);
          setData({ ...formData, lat: lat, lng: lng });
          setIsEnable(true);
        }
        if (latlng === null) {
          setIsEnable(false);
          // setlocationData({ ...locationData, isLat: "", isLong: "" });
        }
      };

    const handleModalHide = () => {
        //
    }

    return (
        <Layout
            title={localization.addAddress}
            // Buttons={headerBtns}
            //className={isFiled ? 'requiredFileds' : ''}
            isGoback
            isLoading={isLoading}
            //linkUrl={`${baseUrl}/finance-business-list`}
        >   
        <FormSection title={localization.searchLocation}>
        <div className="row">
            <div className='col-md-3'>
              <SearchLocation
                handleCurrentLocationBlur={handleCurrentLocationBlur}
                isError={isInputError.crl}
                value={optOption.currentLocation}
                handleCurrentLocationChange={handleCurrentLocationChange}
              />
            </div>
            <div className="col-md-3 col-sm-12">
                <ConstantInput
                    value={formData.lat}
                    label={localization.lat}
                    errorMsg={localization.requiredLatitude}
                    type="text"
                    required
                    handleChange={(value) => setData({ ...formData, lat: value })}
                    isStarRequired={true}
                    fullWidth
                />
            </div>
            <div className="col-md-3 col-sm-12">
                <ConstantInput
                    value={formData.lng}
                    label={localization.lng}
                    errorMsg={localization.requiredLongitude}
                    type="text"
                    required
                    handleChange={(value) => setData({ ...formData, lng: value })}
                    isStarRequired={true}
                    fullWidth
                />
            </div>
        </div>
        
    </FormSection>
    <FormSection title={localization.registeredName}>
        <div className="row">
            <div className="col-md-12 col-sm-12">
                <ConstantInput
                    value={formData.registered_name}
                    label={localization.registeredName}
                    //errorMsg={localization.requiredLatitude}
                    type="text"
                    required
                    handleChange={(value) => setRegisteredName(value)}
                    //isStarRequired={true}
                    fullWidth
                />
            </div>
        </div>
        
    </FormSection>
    {/* {showAddForm && */}
    <Location
        locationCity={locationCity}
        cities={cities}
        locationZone={locationZone}
        zones={zones}
        locationArea={locationArea}
        areas={areas}
        locationType={locationType}
        locTypesData={locTypesData}
        handleValue={handleLocSubmit}
        locationState={locationState}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        getCurrentLocation={getCurrentLocation}
        latlng={latlng}
        toastMsg={toastMsg}
        isDefalut={isDefalut}
        lat={formData.lat}
        lng={formData.lng}
        currentLocation={currentLocation}
    />
    {/* } */}
    <Fragment>
        <div className="btn-group col-2">
            <Button
                onClick={handleSubmit}
                className="d-none d-md-inline-block
    d-md-none d-block xs-fullwidth btncrp submit-dtl-btn"
            >
                <div className="submit-dtl-btn">
                    {localization.submitDtl}
                </div>
                <img src={Images?.ArrowRight} alt="" />
            </Button>
        </div>
    </Fragment>
    <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
    >
    <div className="text-center">
        <div className="success">
            <img src={Images?.tick} alt="" />
        </div>
        <h5>{localization.leadSuccess}</h5>
        <Link
            to={`${baseUrl}/finance-business-list`}
            className="btn btn-primary mb-4"
        >
            Project List <img src={Images?.ArrowRight} alt="" />
        </Link>
    </div>
    </ModalPop>
</Layout>    
 );
};

export default AddLocationDetailsAll;
